import React, { HTMLAttributes } from 'react';

type Props = HTMLAttributes<SVGElement>;

export const LinkedinIcon = ({ ...all }: Props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...all}
  >
    <path
      d='M0.36923 24H5.35385V7.93846H0.36923V24ZM2.86154 0C1.29231 0 0 1.29231 0 2.86154C0 4.43077 1.29231 5.72308 2.86154 5.72308C4.43077 5.72308 5.72308 4.43077 5.72308 2.86154C5.72308 1.29231 4.43077 0 2.86154 0ZM18 7.56923C15.6 7.56923 13.9385 8.86154 13.2923 10.1538H13.2V7.93846H8.4V24H13.3846V16.0615C13.3846 13.9385 13.7538 11.9077 16.3385 11.9077C18.9231 11.9077 18.9231 14.3077 18.9231 16.1538V24H24V15.2308C24 10.8923 23.0769 7.56923 18 7.56923Z'
      fill='white'
    />
  </svg>
);
